import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ArticleFlat, HandbookV2 } from 'types'

type Subject = HandbookV2 | ArticleFlat

const isHandbook = (subject?: Subject): subject is HandbookV2 => {
  return !!subject && 'cascading_share' in subject
}

const useSlugSentry = (subject?: Subject) => {
  const history = useHistory()
  const subjectSlug = isHandbook(subject) ? subject.seo_string : subject?.slug
  const subjectId = isHandbook(subject) ? subject.key : subject?.id
  const replacement = isHandbook(subject) ? subject.seo_string : subject?.slug

  useEffect(() => {
    if (!subjectSlug || !subjectId || !replacement) return

    if (subject && history.location.pathname.includes(subjectId) && !history.location.pathname.includes(subjectSlug)) {
      let pathArray = history.location.pathname.split('/')
      pathArray = pathArray.map((path) => (path.includes(subjectId) ? replacement : path))
      const path = pathArray.join('/') + history.location.search
      history.replace(path)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectSlug])
}

export { useSlugSentry }
